import { atom } from "jotai";
import { EPHEMERAL_NODE_TYPES } from "@zapier/canvas-constants";
import { isValidUUID } from "../utils";
import { EphemeralNodeType } from "../types";
import { canvasIdAtom } from "../canvas";
import { nodesAtom } from "./nodesAtom";

/**
 * To determine whether you're in draft or build mode:
 *
 * Global checks:
 *   - canvasIdAtom: AI and template pages will have no canvas id
 *   - isDraftModeExcludingTemplatesAtom: true if you're on the AI page or blank canvas using AI Co-pilot.
 *   - isDraftModeIncludingTemplatesAtom: true (like ⬆️) but includes template page
 *
 * Node-level checks:
 *   - isDraftOrTemplateNode: true if node is draft or in a template (use this when you want to target AI stuff AND template nodes)
 *   - isDraftNotTemplateNode: true if node is draft but NOT a template node (use this when you want to target AI stuff but NOT template nodes)
 */
export const isDraftModeIncludingTemplatesAtom = atom((get) => {
  const canvasId = get(canvasIdAtom);

  if (!canvasId) {
    return true;
  }

  const nodes = get(nodesAtom);
  return nodes.some(
    (node) =>
      // skip nodes we never persist
      !EPHEMERAL_NODE_TYPES.includes(node.type as EphemeralNodeType) &&
      !isValidUUID(node.id),
  );
});

isDraftModeIncludingTemplatesAtom.debugLabel =
  "isDraftModeIncludingTemplatesAtom";
